import { gql, useMutation } from '@apollo/client';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { GET_ALL_CART_PRODUCTS } from './useCart';

function useValidateCart({ cartData }) {
  const [errors, setErrors] = useState([]);
  const isAuthenticated = useSelector(state => state.Auth.isAuthenticated);
  const user = useSelector(state => state.Auth.user);
  const [validateCart, { loading, error, data }] = useMutation(VALIDATE_CART, {
    refetchQueries: response => {
      const data = JSON.parse(response.data.validateCart.data);
      if (
        data.isNotPurchasable.length > 0 ||
        data.productsWithNotEnoughInventory.length > 0
      ) {
        return [
          {
            query: GET_ALL_CART_PRODUCTS
          }
        ];
      } else {
        return [];
      }
    },
    onCompleted(response) {
      const data = JSON.parse(response.validateCart.data);
      let errors = [];
      if (data.isNotPurchasable.length > 0) {
        errors.push(
          'The following products were removed from your cart as they are not longer available: ' +
            data.isNotPurchasable.join()
        );
      }

      if (data.productsWithNotEnoughInventory.length > 0) {
        errors.push(
          `We've reduced the quantity of the following products because there is not 
          enough stock: ${data.productsWithNotEnoughInventory.join()}`
        );
      }

      if (errors.length > 0) {
        setErrors(errors);
      }
    }
  });

  useEffect(() => {
    if (user) {
      if (user.id) {
        validateCart({
          variables: { user_id: user.id, action: 'purge' }
        });
      }
    }
  }, []);

  return [errors, data];
}

export default useValidateCart;

const VALIDATE_CART = gql`
  mutation validateCart($user_id: ID!, $action: String!) {
    validateCart(user_id: $user_id, action: $action) {
      success
      data
    }
  }
`;
